/** ******** 内容管理 ********* */

// App启动页列表查询
export const getAppStarupConfigureList = {
  url: '/admin/appStartupConfig/getAppStartupConfigInfo.json',
  method: 'get'
};

// 添加app启动页配置
export const addAppStarup = {
  url: '/admin/appStartupConfig/saveStartupConfig.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 删除App启动页配置
export const delAppStarup = {
  url: '/admin/appStartupConfig/delStartupConfig.json',
  method: 'post'
};

// 修改配置项装填
export const updateAppSratupStatus = {
  url: '/admin/appStartupConfig/updateStatus.json',
  method: 'post'
};

// 获取轮播图配置列表
export const getCarouselConfigureList = {
  url: '/admin/slideshowConfig/getSlideshowConfigInfo.json',
  method: 'get'
};

// 新增轮播图
export const addCarouselConfigure = {
  url: '/admin/slideshowConfig/saveSlideshowConfig.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 删除轮播图配置
export const delCarouselConfigure = {
  url: '/admin/slideshowConfig/delSlideshowConfig.json',
  method: 'post'
};

// 导出轮播图列表
export const exportCarouselList = {
  url: '/admin/slideshowConfig/exportSlideList.json'
};

// 获取平台列表
export const getPlatformNoticeList = {
  url: '/admin/information/getInformationList.json',
  method: 'get'
};

// 获取团队列表
export const getTeamList = {
  url: '/admin/salesman/supplier_dialog_data',
  method: 'get'
};

// 获取业务员列表
export const getPersonList = {
  url: '/admin/salesman/get_data',
  method: 'get'
};

// 添加公告
export const saveNotice = {
  url: '/admin/information/saveInformation.json',
  method: 'post'
};

export const deleteNotice = {
  url: '/admin/information/batchDeleteInformation.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 获取平台公告资讯详情
export const getNoticeDetail = {
  url: '/admin/information/edit.json',
  method: 'get'
};

// 公告置顶
export const noticeTopping = {
  url: '/admin/information/updateInformation.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 导出公告
export const exportNotice = {
  url: '/admin/information/exportSalesmanAsync.json'
};
